import { Image } from "@shared/graphql";

import { Options, Splide, SplideSlide, SplideTrack } from "@splidejs/react-splide";
import SpriteSvg from "../common/svg";
import RatioImage from "../medias/ratio-image";
import { classNames } from "@ct-react/core";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

import "./carousel-full-screen.scss";
import React from "react";

type Props = {
  images : Image[],
  opened : boolean,
  setFullScreenOpen : Dispatch<SetStateAction<boolean>>
};

const carousel_option: Options = {
  pagination: false,
  perPage:1,
  height: "80vh",
  width: "1468px",
  padding: "2.625rem",
  keyboard: "global",
  breakpoints: {
    992:{
      width: "100vw",
      fixedWidth: "100vw",
      gap: "2rem",
      padding: "0px",
    },
  },
};

const thumbsOptions: Options = {
  type        : 'slide',
  rewind      : true,
  gap         : 0,
  pagination  : false,
  fixedWidth  : 100,
  fixedHeight : 70,
  cover       : true,
  focus       : 'center',
  isNavigation: true,
  arrows      : false,
};

const FullScreenCarousel = ({
  images,
  opened,
  setFullScreenOpen
}:Props) => {

  const [currentCount, setCurrentCount] = useState<number>(1)
  const mainRef = React.createRef<Splide>();
  const thumbsRef = React.createRef<Splide>();

  useEffect(() =>{
    if ( mainRef.current && thumbsRef.current && thumbsRef.current.splide ) {
      mainRef.current.sync( thumbsRef.current.splide );
    }
  },[])

  const generateSlides = (images:Image[]) => {
    return images.map((image:Image, i:number) => <SplideSlide key={i}>
                <RatioImage key={i} className="preview-img" ratio="3/2" source={image.assets} />
              </SplideSlide>);
  }

  const handleOnMove = (el:any) => {
    setCurrentCount(el.index + 1);
  }

  return(
    <div className={classNames("carousel-fullscreen",{"opened": opened})}>
      <button type="button" className="close-carousel" onClick={() => setFullScreenOpen(false)}>
        <SpriteSvg id="xmark"/>
      </button>
      <div className="count"><span className="current">{currentCount}</span> | <span>{images.length}</span></div>
      <Splide hasTrack={ false } options={carousel_option} ref={mainRef} onMove={handleOnMove} >
        <div className="splide__arrows">
            <button className="splide__arrow splide__arrow--prev">
              <SpriteSvg id="chevron-right"/>
            </button>
            <button className="splide__arrow splide__arrow--next">
              <SpriteSvg id="chevron-right"/>
            </button>
        </div>
        <SplideTrack>
          {generateSlides(images)}
        </SplideTrack>
      </Splide>

      <Splide
        options={ thumbsOptions }
        ref={ thumbsRef }
        aria-label="The carousel with thumbnails. Selecting a thumbnail will change the main carousel"
      >
        {generateSlides(images)}
      </Splide>
    </div>
  );
}

export default FullScreenCarousel;
